<template>
  <div class="user-search-machine">
    <div v-if="!isRenewal" style="padding: 15px; display: flow-root">
      <div style="float: left; line-height: 32px; height: 32px; font-size: 15px">
        <el-button
          size="small"
          v-hasPerm="['user:machine:export']"
          icon="el-icon-receiving"
          @click="exportUserMachine"
          style="margin-right: 5px"
          >{{ $t("common.export") }}</el-button
        >
        <el-button
          size="small"
          v-hasPerm="['renewal:record:insert']"
          type="warning"
          icon="el-icon-goods"
          :disabled="selectList.length <= 0"
          @click="batchRenewal"
          style="margin-right: 5px; margin-left: 0"
          >{{ $t("searchUserMachine.renew") }}</el-button
        >

        <!-- 回收 -->
        <el-button
          type="danger"
          v-hasPerm="['machine:user:recover']"
          size="small"
          icon="el-icon-delete"
          :disabled="selectList.length <= 0"
          @click="recoverMachine"
          style="margin: 0"
          >{{ $t("searchMachine.recover") }}</el-button
        >
      </div>
      <div style="float: right; line-height: 32px; height: 32px">
        <el-form
          ref="userEquipment"
          :model="search"
          :inline="true"
          label-width="10px"
          size="small"
          class="demo-form-inline el-input-height"
        >
          <el-form-item prop="equipmentName" style="margin: 0 10px 0 0">
            <el-input v-model="search.equipmentName" :placeholder="$t('searchOrder.equipmentName')"></el-input>
          </el-form-item>
          <el-form-item prop="equipmentNo" style="margin: 0 10px 0 0">
            <el-input v-model="search.equipmentNo" :placeholder="$t('searchUserMachine.equipmentNo')"></el-input>
          </el-form-item>
          <el-form-item prop="userName" style="margin: 0 10px 0 0">
            <el-input v-model="search.userName" :placeholder="$t('searchUserMachine.userName')"></el-input>
          </el-form-item>
          <el-form-item prop="rentState" style="margin: 0 10px 0 0">
            <el-select
              v-model="search.rentState"
              filterable
              :no-data-text="$t('common.noData')"
              :no-match-text="$t('common.noData')"
              :placeholder="$t('searchUserMachine.rentState')"
            >
              <el-option
                v-for="item in rentStateList"
                :key="item.id"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="enableStatus" style="margin: 0 10px 0 0">
            <el-select
              v-model="search.enableStatus"
              filterable
              :no-data-text="$t('common.noData')"
              :no-match-text="$t('common.noData')"
              :placeholder="$t('searchUserMachine.enableStatus')"
            >
              <el-option v-for="item in yesNo" :key="item.id" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="equipmentName" style="margin: 0 10px 0 0">
            <el-select
              v-model="columnsList"
              multiple
              collapse-tags
              :no-data-text="$t('common.noData')"
              :no-match-text="$t('common.noData')"
              :placeholder="$t('user.SearchUserMachine.602960-0')"
              @change="handlerChangeColumns"
            >
              <el-option
                v-for="item in allColumnsList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item style="margin: 0">
            <el-button type="primary" @click="onSubmit" icon="el-icon-search">{{ $t("common.search") }}</el-button>
            <el-button @click="resetSearch('userEquipment')" icon="el-icon-refresh">{{ $t("common.reset") }}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <!-- 立即续费进来的 -->
    <div v-else style="padding: 15px; display: flow-root">
      <div style="float: left; line-height: 32px; height: 32px; font-size: 15px">
        <el-button
          size="small"
          v-hasPerm="['user:machine:export']"
          icon="el-icon-magic-stick"
          @click="handlerBackAll"
          style="margin-right: 5px"
          >{{ $t("common.backAll") }}</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "SearchUserMachine",
    props: {
      search: Object,
      selectList: Array,
      yesNo: Array,
      appTypeList: Array,
      machineType: Array,
      machineGroup: Array,
      rentStateList: Array,
      allColumnsList: Array,
      isRenewal: Boolean
    },
    data() {
      return {
        columnsList: []
      };
    },
    methods: {
      handlerChangeColumns(e) {
        this.$emit("handlerChangeColumns", e);
      },
      recoverMachine() {
        this.$emit("recoverMachine");
      },
      exportUserMachine() {
        this.$confirm(this.$t("searchUserMachine.export"), this.$t("common.tip"), {
          confirmButtonText: this.$t("common.definite"),
          cancelButtonText: this.$t("common.cancel"),
          type: "warning"
        })
          .then(() => {
            this.$api.download(this.$url.UserMachine.export, this.search);
          })
          .catch(err => {
            this.$message.error(err.msg);
          });
      },
      batchRenewal() {
        if (this.selectList.length <= 0) {
          this.$message.warning(this.$t("searchUserMachine.check"));
        } else {
          this.$emit("batchRenewal");
        }
      },
      onSubmit() {
        this.$emit("onSubmit", this.search);
      },
      handlerBackAll() {
        this.$emit("handlerBackAll");
      },
      resetSearch(formName) {
        this.$refs[formName].resetFields();
        this.$toolUtil.clearForm(this.search);
        this.$emit("resetSearch", this.search);
      }
    }
  };
</script>

<style scoped>
  ::v-deep .el-input-height input {
    width: 1.6rem;
  }
</style>
